import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function DashboardRedirect() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (loading) return;
    if (!user) { navigate("/login", { replace: true }); return; }
    if (!user.role) { navigate("/select-role", { replace: true }); return; }
    const map = {
      candidate: "/candidate/dashboard",
      employer: "/employer/dashboard",
      recruiter: "/employer/dashboard",
      admin: "/admin/dashboard",
      super_admin: "/admin/dashboard",
    };
    navigate(map[user.role] || "/", { replace: true });
  }, [user, loading, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="w-10 h-10 border-4 border-[#D96B27] border-t-transparent rounded-full animate-spin" />
    </div>
  );
}
